module.exports = __webpack_public_path__ + "assets/HomeMarker-old-6e61fc.svg";